<template>
  <div class="tab-content clearfix">
    <div class="tab-pane fade active in" :id="tab">
      <div class="drive">
        <div :class="[isList ? 'lists' : 'grids']" style="display: block">
          <keep-alive>
            <TableHeaderShareResource
              :isList="isList"
              @handleSaveSelected="handleSaveSelected"
            ></TableHeaderShareResource>
          </keep-alive>
          <div class="list-content">
            <div
              v-for="data in datas"
              :key="data.number"
              class="itemlist"
              :class="{
                act: data.isSelected ? true : false,
                itemlist2: !isList && isThumb(data.file_ext),
              }"
              @contextmenu.prevent="rightEvent(data, $event)"
              @click="selectRow(data)"
            >
              <div class="item-check">
                <div class="checkbox">
                  <i class="ti-check"></i>
                </div>
              </div>
              <div
                class="item-name"
                :style="imgPathFilter(data)"
                @click.stop="handleClickIcon(data)"
              >
                <div class="file-icon">
                  <svg
                    aria-hidden="true"
                    class="icon"
                    v-if="(!isThumb(data.file_ext) && !isList) || isList"
                  >
                    <use
                      :xlink:href="
                        '#icon-' +
                        getIcon(data.type, data.file_type, data.file_ext)
                      "
                    />
                  </svg>
                </div>
                <p>
                  <a
                    @click.stop="handleClickIcon(data)"
                    :title="data | formatData"
                    >{{ data | formatData }}</a
                  >
                </p>
                <!-- <span
                  v-if="
                    (showOnSharefile || showOnGroupSend) &&
                    data.file_type === 'video'
                  "
                  :class="data | transcodeStatusFilter"
                  class="isTransed"
                  :title="data.transcode_title"
                  @click.stop="fileTranstate(data, $event)"
                ></span> -->
                <!-- <span
                  v-if="
                    !(showOnSharefile || showOnGroupSend) &&
                    data.file_type === 'video'
                  "
                  :class="data | transcodeStatusFilter"
                  class="isTransed"
                  :title="data.transcode_title"
                  @click.stop="shareFileTranstate(data, $event)"
                ></span> -->
                <span
                  v-if="data.is_lock === true || data.review_status === 'block'"
                  class="glyphicon glyphicon-lock isLocked"
                  :title="data.lock_reason ? data.lock_reason : '锁定'"
                ></span>
              </div>

              <div class="item-size" v-if="isList">
                {{ data | bytesToSize }}
              </div>
              <div class="item-time" v-if="isList">
                <span class="item-date-sm">{{
                  data.last_update_date ? data.last_update_date : "-"
                }}</span>
              </div>
              <div class="item-author" v-if="isList">
                {{
                  data.creater_user_real_name
                    ? data.creater_user_real_name
                    : "-"
                }}
              </div>
              <div
                class="item-menu"
                v-show="
                  showOnGroupSend ||
                  showOnGroupShare ||
                  showOnShareme ||
                  (showOnSharefile && data.type === 'file')
                "
              >
                <div
                  class="dropdown"
                  v-if="
                    showOnShareme || showOnGroupShare || data.type === 'file'
                  "
                >
                  <a
                    aria-expanded="true"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    id="dropdownMenu2"
                    data-toggle="dropdown"
                    @click.stop="toggleDropdown($event)"
                  >
                    <i class="iconfont icon-more" title="更多"></i>
                  </a>
                  <ul
                    aria-labelledby="dropdownMenu2"
                    class="dropdown-menu dropdown-menu-right"
                  >
                    <li v-if="data.type === 'file' && showOnGroupSend">
                      <a @click="sendPreview(data)">
                        <i class="glyphicon glyphicon-eye-open"></i>
                        预览
                      </a>
                    </li>
                    <li v-if="right__share_saveResource && (showOnShareme || showOnGroupShare)">
                      <a @click.stop="handleSave(data, 'save')">
                        <i class="ti-harddrives"></i>
                        保存到
                      </a>
                    </li>
                    <li
                      v-if="
                        data.type === 'file' &&
                        (showOnSharefile || showOnGroupSend)
                      "
                    >
                      <a @click.stop="download(data)">
                        <i class="ti-download"></i>
                        下载
                      </a>
                    </li>
                    <li v-if="data.type === 'file' && showOnGroupSend">
                      <a @click="handleClickIcon(data)">
                        <i class="iconfont icon-share"></i>
                        获取链接
                      </a>
                    </li>
                    <li
                      v-if="
                        data.type === 'file' &&
                        (showOnShareme || showOnGroupShare)
                      "
                    >
                      <a @click.stop="shareDownload(data)">
                        <i class="ti-download"></i>
                        下载
                      </a>
                    </li>
                    <li
                      v-if="
                        right__share_resource_report_create && (data.type === 'file' &&
                        (showOnShareme || showOnGroupShare))
                      "
                    >
                      <a
                        data-toggle="modal"
                        data-target="#complaint"
                        @click="handleData(data)"
                      >
                        <i class="iconfont icon-jvbao"></i>
                        举报
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="loadingbox" v-show="loading">
              <section class="loading Animation1">
                <section class="shape shape-1"></section>
                <section class="shape shape-2"></section>
                <section class="shape shape-3"></section>
                <section class="shape shape-4"></section>
              </section>
              <h4>正在加载，请稍后……</h4>
            </div>
            <div class="nofile" v-if="nothing">
              <div class="pic">
                <img src="@/assets/images/nofile.svg" />
              </div>
              <h4>这里还没任何文件</h4>
              <p></p>
            </div>
            <div class="nofile" v-if="shareExpired">
              <div class="pic">
                <img src="@/assets/images/timeout.svg" />
              </div>
              <h4>您来晚了，文件分享已过期。</h4>
              <div class="nobtn">
                <button
                  class="btn btn-default"
                  type="button"
                  @click="removeShare"
                >
                  <i class="iconfont icon-trash"></i>
                  移除该分享
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Save
      :resources="resources"
      :folder="folder"
      v-if="status.SaveStatus"
    ></Save>
    <TableComplaint
      :detail="detail"
      v-if="status.TableComplaintStatus"
    ></TableComplaint>
    <TableComplaintSelected
      v-if="status.TableComplaintSelectedStatus"
    ></TableComplaintSelected>
    <TableSendDetail
      :open="sendDetailDialogStatus"
      @close="closeSendDetailDialog"
      v-if="status.TableSendDetailStatus"
    ></TableSendDetail>
    <markdownPreview
      :detail="detail"
      dialogStatus="view"
      v-if="status.markdownPreviewStatus"
    ></markdownPreview>
    <videoPreview
      :detail="detail"
      v-if="status.videoPreviewStatus"
    ></videoPreview>
    <audioPreview
      :detail="detail"
      v-if="status.audioPreviewStatus"
    ></audioPreview>
    <txtPreview :detail="detail" v-if="status.txtPreviewStatus"></txtPreview>
    <officePreview
      :detail="detail"
      v-if="status.officePreviewStatus"
    ></officePreview>
    <pdfPreview
      :detail="detail"
      dialogStatus="view"
      v-if="status.pdfPreviewStatus"
    ></pdfPreview>
    <imgPreview :imgs="imgs" v-if="status.imgPreviewStatus"></imgPreview>
    <div
      class="right-menu"
      :style="rightMenustyle"
      v-if="showRightMenu"
      v-clickoutside="closeRightMenu"
    >
      <a
        v-if="right__share_saveResource && (showOnShareme || showOnGroupShare)"
        @click="handleSave(detail, 'save')"
      >
        <i class="ti-harddrives"></i>
        保存到
      </a>
      <a
        v-show="detail.type === 'file' && !showOnGroupSend"
        @click="sharePreview(detail)"
      >
        <i class="glyphicon glyphicon-eye-open"></i>
        预览
      </a>
      <a
        v-show="detail.type === 'file' && showOnGroupSend"
        @click="sendPreview(detail)"
      >
        <i class="glyphicon glyphicon-eye-open"></i>
        预览
      </a>
      <a
        v-show="detail.type === 'file' && (showOnSharefile || showOnGroupSend)"
        @click="download(detail)"
      >
        <i class="ti-download"></i>
        下载
      </a>
      <a
        v-show="detail.type === 'file' && showOnGroupSend"
        @click="handleClickIcon(detail)"
      >
        <i class="iconfont icon-share"></i>
        获取链接
      </a>
      <a
        v-show="detail.type === 'file' && (showOnShareme || showOnGroupShare)"
        @click="shareDownload(detail)"
      >
        <i class="ti-download"></i>
        下载
      </a>
      <a
        v-if="right__share_resource_report_create && (detail.type === 'file' && (showOnShareme || showOnGroupShare))"
        data-toggle="modal"
        data-target="#complaint"
        @click="handleData(detail)"
      >
        <i class="iconfont icon-jvbao"></i>
        举报
      </a>
    </div>
  </div>
</template>

<script>
import {
  getFileInfo,
  fileTranstate,
  fileTranstateStatus,
  download,
  preview,
} from "@/api/drive/drive";
import { previewTxts } from "@/config/index";
import { getIcon, getPreviewType } from "@/utils/icon";
import {
  bytesToSize,
  formatData,
  formatSeconds,
  listToTree,
  transcodeStatusFilter,
  isThumb,
} from "@/utils/index";
import {
  shareDownload,
  sharePreview,
  shareFileTranstate,
  shareTranstateStatus,
  removeShare,
  linkResourceInfo,
} from "@/api/share/share";
export default {
  name: "Table",
  components: {
    TableHeaderShareResource: () =>
      import("./TableHeader/TableHeaderShareResource"),
    markdownPreview: () => import("./TablePreview/markdownPreview"),
    videoPreview: () => import("./TablePreview/videoPreview"),
    audioPreview: () => import("./TablePreview/audioPreview"),
    imgPreview: () => import("./TablePreview/imgPreview"),
    txtPreview: () => import("./TablePreview/txtPreview"),
    officePreview: () => import("./TablePreview/officePreview"),
    pdfPreview: () => import("./TablePreview/pdfPreview"),
    TableSendDetail: () => import("./TableOperate/TableSendDetail"),
    TableComplaint: () => import("./TableOperate/TableComplaint"),
    TableComplaintSelected: () =>
      import("./TableOperate/TableComplaintSelected"),
    Save: () => import("@/components/Save"),
  },
  props: {
    isList: Boolean,
  },
  data() {
    return {
      sendDetailDialogStatus: false,
      status: {
        TableSendDetailStatus: false,
        TableComplaintStatus: false,
        TableComplaintSelectedStatus: false,
        SaveStatus: false,
        markdownPreviewStatus: false,
        videoPreviewStatus: false,
        audioPreviewStatus: false,
        txtPreviewStatus: false,
        officePreviewStatus: false,
        pdfPreviewStatus: false,
        imgPreviewStatus: false,
      },
      rightMenustyle: {},
      showRightMenu: false,
      resources: [],
      PreviewType: "unknow",
      imgs: [],
      detail: {},
    };
  },
  filters: {
    transcodeStatusFilter: transcodeStatusFilter,
    formatData: formatData,
    bytesToSize: bytesToSize,
  },
  computed: {
    right__share_resource_report_create() {
      return this.$store.getters.right__share_resource_report_create
    },
    right__share_saveResource() {
      return this.$store.getters.right__share_saveResource
    },
    share() {
      return this.$store.state.drive.share;
    },
    shareExpired() {
      return this.$store.state.drive.shareExpired;
    },
    loading() {
      return this.$store.state.drive.loading;
    },
    nothing() {
      return this.$store.state.drive.nothing;
    },
    folder() {
      return this.$store.state.drive.selectedFolder;
    },
    selectedDatas() {
      return this.$store.state.drive.selectedDatas;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
    tab() {
      return this.$store.state.drive.tab;
    },
    showOnSharefile: function () {
      return this.tab === "sharefile" || this.tab === "persona-sharefile";
    },
    showOnShareme: function () {
      return this.tab === "shareme";
    },
    showOnGroupShare: function () {
      return this.tab === "group-share" || this.tab === "groupdisk-share";
    },
    showOnGroupSend: function () {
      return this.tab === "group-send" || this.tab === "groupdisk-send";
    },
    datas() {
      return this.$store.state.drive.datas;
    },
  },
  directives: {
    clickoutside: {
      bind(el, binding, vnode) {
        function documentHandler(e) {
          // 这里判断点击的元素是否是本身，是本身，则返回
          if (el.contains(e.target)) {
            return false;
          }
          // 判断指令中是否绑定了函数
          if (binding.expression) {
            // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
            binding.value(e);
          }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener("click", documentHandler);
      },
      unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener("click", el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      },
    },
  },
  methods: {
    isThumb: isThumb,
    imgPathFilter(data) {
      return !this.isList &&
        data.file_type === "image" &&
        isThumb(data.file_ext)
        ? `background: center / cover no-repeat url("${data.imgPath}"), #f1f1f1;`
        : "";
    },
    toggleDropdown(event) {
      $(event.currentTarget).parent().toggleClass("open");
    },
    closeRightMenu() {
      this.showRightMenu = false;
    },
    rightEvent(data, e) {
      this.detail = data;
      this.rightMenustyle = {
        left: e.clientX + 5 + "px",
        top: e.clientY + 5 + "px",
      };
      this.showRightMenu = true;
      this.$store.commit("selectOneRow", data);
    },
    shareFileTranstate(data, event) {
      this.detail = data;
      let e = event.target;
      $(e).css({ "pointer-events": "none" });
      setTimeout(() => {
        $(e).css({ "pointer-events": "auto" });
      }, 5000);
      if (data.transcode_status == "wait" || data.transcode_status == "fail") {
        this.$confirm({
          type: "confirm",
          content: "确定要提交转码吗？",
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            shareFileTranstate({
              share_number: this.share.share_number,
              share_resource_number: data.number,
            })
              .then((res) => {
                if (res.status_code === 202) {
                  this.$store.commit("setTranscode", {
                    data: data,
                    transcode_title: "视频正在转码，请稍等",
                    transcode_status: "progess",
                  });
                  this.$message({
                    type: "success",
                    message: res.message,
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err,
                });
              });
          })
          .catch(() => {});
      } else if (data.transcode_status == "progess") {
        this.shareTranstateStatus(data)
          .then((res) => {
            if (res.status_code === 200) {
              if (res.entity.trans_status == "progess") {
                this.$message({
                  type: "warning",
                  message: `该视频正在转码，已完成${
                    res.entity.trans_percentage
                  }%，预计需要${formatSeconds(res.entity.take_time)}，请稍等`,
                });
              } else if (res.entity.trans_status == "success") {
                this.$store.commit("setTranscode", {
                  data: data,
                  transcode_title: "该视频已转码完成，可以播放",
                  transcode_status: "success",
                });
                this.getSharePreviewPath(data).then(() => {
                  $("#video_preview").modal("show");
                });
              } else if (res.entity.trans_status == "wait") {
                this.$message({
                  type: "warning",
                  message: `该视频正在等待转码，前面排队的数量${
                    res.entity.trans_queue_count
                  }，预计需要${formatSeconds(res.entity.take_time)}，请稍等`,
                });
              } else if (res.entity.trans_status == "fail") {
                this.$store.commit("setTranscode", {
                  data: data,
                  transcode_title: "视频转码失败，点击重试",
                  transcode_status: "fail",
                });
                this.$message({
                  type: "error",
                  message: res.entity.trans_message,
                });
              }
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      }
    },
    // 分享转码状态
    shareTranstateStatus(data) {
      return new Promise((resolve, reject) => {
        shareTranstateStatus({
          share_number: this.share.share_number,
          share_resource_number: data.number,
          share_constraint: null,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 转码状态
    fileTranstateStatus(data) {
      return new Promise((resolve, reject) => {
        fileTranstateStatus({
          number: data.number,
          group_number: this.groupNumber,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fileTranstate(data, event) {
      this.detail = data;
      let e = event.target;
      $(e).css({ "pointer-events": "none" });
      setTimeout(() => {
        $(e).css({ "pointer-events": "auto" });
      }, 5000);
      if (data.transcode_status == "wait" || data.transcode_status == "fail") {
        this.$confirm({
          type: "confirm",
          content: "确定要提交转码吗？",
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            fileTranstate({
              file_number: data.number,
              group_number: this.groupNumber,
            })
              .then((res) => {
                if (res.status_code === 202) {
                  this.$store.commit("setTranscode", {
                    data: data,
                    transcode_title: "视频正在转码，请稍等",
                    transcode_status: "progess",
                  });
                  this.$message({
                    type: "warning",
                    message: res.message,
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err,
                });
              });
          })
          .catch(() => {});
      } else if (data.transcode_status == "progess") {
        this.fileTranstateStatus(data)
          .then((res) => {
            if (res.status_code === 200) {
              if (res.entity.trans_status == "progess") {
                this.$message({
                  type: "warning",
                  message: `该视频正在转码，已完成${
                    res.entity.trans_percentage
                  }%，预计需要${formatSeconds(res.entity.take_time)}，请稍等`,
                });
              } else if (res.entity.trans_status == "success") {
                this.$store.commit("setTranscode", {
                  data: data,
                  transcode_title: "该视频已转码完成，可以播放",
                  transcode_status: "success",
                });
                this.getSendPreviewPath(data).then(() => {
                  $("#video_preview").modal("show");
                });
              } else if (res.entity.trans_status == "wait") {
                this.$message({
                  type: "warning",
                  message: `该视频正在等待转码，前面排队的数量${
                    res.entity.trans_queue_count
                  }，预计需要${formatSeconds(res.entity.take_time)}，请稍等`,
                });
              } else if (res.entity.trans_status == "fail") {
                this.$store.commit("setTranscode", {
                  data: data,
                  transcode_title: "视频转码失败，点击重试",
                  transcode_status: "fail",
                });
                this.$message({
                  type: "error",
                  message: res.entity.trans_message,
                });
              }
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      }
    },
    handleSaveSelected() {
      this.resources = this.selectedDatas;
      this.getTree("save");
    },
    handleSave(data, action = null) {
      this.showRightMenu = false;
      if (data.is_lock) {
        this.$message({
          type: "warning",
          message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (data.review_status === "block") {
        this.$message({
          type: "warning",
          message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
        });
        return false;
      }
      this.resources = [data];
      if (action) {
        this.getTree(action);
      }
    },
    // 预览分享资源
    sharePreview(data) {
      this.showRightMenu = false;
      this.detail = data;
      let type = getPreviewType(data.type, data.file_type, data.file_ext);
      this.PreviewType = type;
      switch (type) {
        case "mp4":
          if (
            data.transcode_status == "none" ||
            data.transcode_status == "success"
          ) {
            this.getSharePreviewPath(data).then(() => {
              $("#video_preview").modal("show");
            });
          } else if (data.transcode_status == "wait") {
            this.$message({
              type: "warning",
              message: "视频暂未转码，请先点击转码，转码完成后即可播放",
            });
          } else if (data.transcode_status == "progess") {
            this.shareTranstateStatus(data)
              .then((res) => {
                if (res.status_code === 200) {
                  if (res.entity.trans_status == "progess") {
                    this.$message({
                      type: "warning",
                      message: `该视频正在转码，已完成${
                        res.entity.trans_percentage
                      }%，预计需要${formatSeconds(
                        res.entity.take_time
                      )}，请稍等`,
                    });
                  } else if (res.entity.trans_status == "success") {
                    this.$store.commit("setTranscode", {
                      data: data,
                      transcode_title: "该视频已转码完成，可以播放",
                      transcode_status: "success",
                    });
                    this.getSharePreviewPath(data).then(() => {
                      $("#video_preview").modal("show");
                    });
                  } else if (res.entity.trans_status == "wait") {
                    this.$message({
                      type: "warning",
                      message: `该视频正在等待转码，前面排队的数量${
                        res.entity.trans_queue_count
                      }，预计需要${formatSeconds(
                        res.entity.take_time
                      )}，请稍等`,
                    });
                  } else if (res.entity.trans_status == "fail") {
                    this.$store.commit("setTranscode", {
                      data: data,
                      transcode_title: "视频转码失败，点击重试",
                      transcode_status: "fail",
                    });
                    this.$message({
                      type: "error",
                      message: res.entity.trans_message,
                    });
                  }
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err,
                });
              });
          } else if (data.transcode_status == "fail") {
            this.$message({
              type: "error",
              message: "视频转码失败，无法播放",
            });
          } else if (data.transcode_status == "notran") {
            this.$message({
              type: "warning",
              message: "该文件暂不支持在线预览",
              // message: "本视频不支持转码，也不支持直接预览",
            });
          }
          break;
        case "audio":
          this.getSharePreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#audio_preview").modal("show");
            });
          });
          break;
        case "office":
          this.getSharePreviewPath(data).then(() => {
            this.dialogStatus = "view";
            this.$nextTick(() => {
              $("#office_preview").modal("show");
            });
          });
          break;
        case "pdf":
          this.getSharePreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#pdf_preview").modal("show");
            });
          });
          break;
        case "markdown":
          this.getSharePreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#markdown_preview").modal("show");
            });
          });
          break;
        case "img":
          this.getSharePreviewPath(data).then(() => {
            this.imgs = this.datas
              .filter((item) => {
                return item.file_type === "image";
              })
              .map((file) => {
                if (file.number === data.number) {
                  file.show = true;
                } else {
                  file.show = false;
                }
                return file;
              });
            this.$nextTick(() => {
              $("#img_preview").modal("show");
            });
          });
          break;
        case "txt":
          this.getSharePreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#txt_preview").modal("show");
            });
          });
          break;
        default:
          if (previewTxts.includes(data.file_ext)) {
            this.getSharePreviewPath(data).then(() => {
              this.$nextTick(() => {
                $("#txt_preview").modal("show");
              });
            });
          } else {
            this.$message({
              type: "warning",
              message: "该文件暂不支持在线预览",
            });
          }
          break;
      }
    },
    // 获取分享的资源预览地址
    getSharePreviewPath(data) {
      return new Promise((resolve) => {
        sharePreview({
          share_number: this.share.share_number,
          share_resource_number: this.detail.number,
          share_constraint: null,
        })
          .then((res) => {
            if (res.status_code === 200) {
              if (data.is_lock) {
                this.$message({
                  type: "warning",
                  message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
                });
                return false;
              }
              if (data.review_status === "block") {
                this.$message({
                  type: "warning",
                  message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
                });
                return false;
              }
              resolve(res);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },

    // 预览发布资源
    sendPreview(data) {
      this.showRightMenu = false;
      this.detail = data;
      let type = getPreviewType(data.type, data.file_type, data.file_ext);
      this.PreviewType = type;
      switch (type) {
        case "mp4":
          if (
            data.transcode_status == "none" ||
            data.transcode_status == "success"
          ) {
            this.getSendPreviewPath(data).then(() => {
              $("#video_preview").modal("show");
            });
          } else if (data.transcode_status == "wait") {
            this.$message({
              type: "warning",
              message: "视频暂未转码，请先点击转码，转码完成后即可播放",
            });
          } else if (data.transcode_status == "progess") {
            this.fileTranstateStatus(data)
              .then((res) => {
                if (res.status_code === 200) {
                  if (res.entity.trans_status == "progess") {
                    this.$message({
                      type: "warning",
                      message: `该视频正在转码，已完成${
                        res.entity.trans_percentage
                      }%，预计需要${formatSeconds(
                        res.entity.take_time
                      )}，请稍等`,
                    });
                  } else if (res.entity.trans_status == "success") {
                    this.$store.commit("setTranscode", {
                      data: data,
                      transcode_title: "该视频已转码完成，可以播放",
                      transcode_status: "success",
                    });
                    this.getSendPreviewPath(data).then(() => {
                      $("#video_preview").modal("show");
                    });
                  } else if (res.entity.trans_status == "wait") {
                    this.$message({
                      type: "warning",
                      message: `该视频正在等待转码，前面排队的数量${
                        res.entity.trans_queue_count
                      }，预计需要${formatSeconds(
                        res.entity.take_time
                      )}，请稍等`,
                    });
                  } else if (res.entity.trans_status == "fail") {
                    this.$store.commit("setTranscode", {
                      data: data,
                      transcode_title: "视频转码失败，点击重试",
                      transcode_status: "fail",
                    });
                    this.$message({
                      type: "error",
                      message: res.entity.trans_message,
                    });
                  }
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err,
                });
              });
          } else if (data.transcode_status == "fail") {
            this.$message({
              type: "error",
              message: "视频转码失败，无法播放",
            });
          } else if (data.transcode_status == "notran") {
            this.$message({
              type: "warning",
              message: "该文件暂不支持在线预览",
              // message: "本视频不支持转码，也不支持直接预览",
            });
          }
          break;
        case "audio":
          this.getSendPreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#audio_preview").modal("show");
            });
          });
          break;
        case "office":
          this.getSendPreviewPath(data).then(() => {
            this.dialogStatus = "view";
            this.$nextTick(() => {
              $("#office_preview").modal("show");
            });
          });
          break;
        case "pdf":
          this.getSendPreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#pdf_preview").modal("show");
            });
          });
          break;
        case "img":
          this.getSendPreviewPath(data).then(() => {
            this.imgs = this.datas
              .filter((item) => {
                return item.file_type === "image";
              })
              .map((file) => {
                if (file.number === data.number) {
                  file.show = true;
                } else {
                  file.show = false;
                }
                return file;
              });
            this.$nextTick(() => {
              $("#img_preview").modal("show");
            });
          });
          break;
        case "txt":
          this.getSendPreviewPath(data).then(() => {
            this.$nextTick(() => {
              $("#txt_preview").modal("show");
            });
          });
          break;
        default:
          if (previewTxts.includes(data.file_ext)) {
            this.getSendPreviewPath(data).then(() => {
              this.$nextTick(() => {
                $("#txt_preview").modal("show");
              });
            });
          } else {
            this.$message({
              type: "warning",
              message: "该文件暂不支持在线预览",
            });
          }
          break;
      }
    },
    // 获取发布的资源预览地址
    getSendPreviewPath(data) {
      return new Promise((resolve) => {
        preview({
          number: data.number,
          group_number: this.groupNumber,
        })
          .then((res) => {
            if (res.status_code === 200) {
              if (data.is_lock) {
                this.$message({
                  type: "warning",
                  message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
                });
                return false;
              }
              resolve(res);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },
    getIcon(type, file_type, file_ext) {
      return getIcon(type, file_type, file_ext);
    },
    selectRow(data) {
      this.$store.commit("selectRow", data);
    },
    // 关闭发布资源详情弹框
    closeSendDetailDialog() {
      this.sendDetailDialogStatus = false;
      $("body").css("overflow", "initial");
    },
    // 获取资源链接
    getLinkResourceInfo(data) {
      this.showRightMenu = false;
      if (
        data.file_type === "video" &&
        data.transcode_status != "success" &&
        data.transcode_status != "none"
      ) {
        if (data.transcode_status == "wait") {
          this.$message({
            type: "warning",
            message: "视频暂未转码，请先点击转码，转码完成后即可播放",
          });
        } else if (data.transcode_status == "progess") {
          this.$message({
            type: "warning",
            message: "视频正在转码，请稍等",
          });
        } else if (data.transcode_status == "fail") {
          this.$message({
            type: "error",
            message: "视频转码失败，无法播放",
          });
        } else if (data.transcode_status == "notran") {
          this.$message({
            type: "warning",
              message: "该文件暂不支持在线预览",
              // message: "本视频不支持转码，也不支持直接预览",
          });
        }
        return false;
      }
      linkResourceInfo({
        link_number: this.share.link_number,
        resource_number: data.number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setShareInfo", res.entity);
            $("body").css("overflow", "hidden");
            this.sendDetailDialogStatus = true;
            // 获取预览地址和使用的预览组件
            this.getSendPreviewPath(data).then((res2) => {
              let type = getPreviewType(
                data.type,
                data.file_type,
                data.file_ext
              );
              let preview_path = res2.entity.preview_path;
              if (
                res2.entity.category === "video" &&
                !res2.entity.is_preview &&
                res2.entity.trans_path
              ) {
                preview_path = res2.entity.trans_path;
              }
              this.$store.commit("setPreviewData", {
                file_ext: data.file_ext,
                position: "inside",
                preview_path: preview_path,
                previewer: type + "Preview",
              });
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 文件图标/名称点击事件
    handleClickIcon(data) {
      if (data.type === "file") {
        if (this.showOnGroupSend) {
          this.getLinkResourceInfo(data);
        } else {
          this.sharePreview(data);
        }
      } else if (data.type === "folder") {
        this.getResourceList(data);
      }
    },
    getResourceList(data) {
      if (this.showOnGroupSend) {
        this.$emit("getLinkResourceList", data);
      } else {
        this.$emit("getShareResourceList", data);
      }
    },
    handleData(data, action = null) {
      this.showRightMenu = false;
      this.detail = data;
      if (action) {
        this.getTree(action);
      }
    },
    getTree(action) {
      let that = this;
      getFileInfo({
        group_number: null, //此处仅用户[保存到]功能,不需要group_number
        number: 0,
        is_rec: true,
        category: "folder",
        disk_type: "cloud",
      })
        .then((res) => {
          let tree = [
            {
              disk_type: "cloud",
              number: "0",
              text: "我的云盘",
              nodes: listToTree(res.entity.datas),
            },
          ];
          $("#treeview-" + action).treeview({
            expandIcon: "ti ti-angle-right",
            collapseIcon: "ti ti-angle-down",
            nodeIcon: "iconfont icon-folder",
            showTags: true,
            onNodeSelected: function (event, data) {
              that.$store.commit("selectedFolder", data);
            },
            onNodeUnselected: function (event, data) {
              that.$store.commit("selectedFolder", null);
            },
            data: tree,
          });
          $("#" + action).on("hidden.bs.modal", function (e) {
            that.resources = [];
          });
          $("#" + action).modal("show");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    download(data) {
      this.showRightMenu = false;
      if (data.is_lock) {
        this.$message({
          type: "warning",
          message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (data.review_status === "block") {
        this.$message({
          type: "warning",
          message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
        });
        return false;
      }
      let params = {
        files_list: [data.number],
        group_number: this.groupNumber,
      };
      download(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[data.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    shareDownload(data) {
      this.showRightMenu = false;
      if (data.is_lock) {
        this.$message({
          type: "warning",
          message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
        });
        return false;
      }
      if (data.review_status === "block") {
        this.$message({
          type: "warning",
          message: `该文件因未通过内容审核，已被锁定。如需解锁，请联系管理员`,
        });
        return false;
      }
      let params = {
        share_number: this.$store.state.drive.share.share_number,
        share_resources_list: [data.number],
      };
      shareDownload(params)
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[data.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    removeShare() {
      removeShare({
        share_number: [this.$store.state.drive.share.share_number],
        sharer_target_number: this.$store.state.user.userInfo.user_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$message({
              type: "success",
              message: res.message,
            });
            this.$emit("getShareResourceList", "up");
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  mounted() {
    setTimeout(() => {
      for (let key in this.status) {
        this.status[key] = true;
      }
    }, 500);
  },
};
</script>

<style scoped>
.isLocked {
  font-size: 12px;
  margin-left: 3px;
  opacity: 0.65;
  color: #aaa;
}
.isTransed {
  font-size: 12px;
  margin-left: 3px;
}
.drive .grids .itemlist2 {
  padding: 20px 20px 50px 20px !important;
}
.drive .grids .itemlist2 .item-name {
  width: 100%;
  height: 100%;
  padding-top: 85px;
  background-color: #f1f1f1;
}
.drive .grids .itemlist2 p {
  margin-top: 5px;
}
</style>